import { useState, useEffect, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../context/AuthContext";
import { fetchVendorById } from "../state/slices/vendorSlice";
import { fetchCouponsByVendor } from "../state/slices/couponSlice";
import { fetchBusinessesByVendor } from "../state/slices/businessSlice";
import { fetchBookmarks, addBookmark, removeBookmark } from "../state/slices/bookmarkSlice";

const VendorTwoDetails = () => {
  const [grid] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const { isAuthenticated, isSubscribed, token } = useAuth();
  const bookmarkedIds = useSelector(state => state.bookmarks.bookmarkedIds);

  useEffect(() => {
    if (isAuthenticated && token) dispatch(fetchBookmarks(token));
  }, [isAuthenticated, token, dispatch]);

  const handleBookmarkToggle = (e, couponId) => {
    e.stopPropagation();
    if (!isAuthenticated) return;
    if (bookmarkedIds.includes(couponId)) {
      dispatch(removeBookmark({ couponId, token }));
    } else {
      dispatch(addBookmark({ couponId, token }));
    }
  };

  const vendor = useSelector(state => state.vendors.vendors[id] || state.vendors.currentVendor);
  const vendorCoupons = useSelector(state => state.coupons.vendorCoupons);
  const vendorBusinesses = useSelector(state => state.businesses.vendorBusinesses);

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedBusiness, setSelectedBusiness] = useState(null);

  const coupons = useMemo(
    () => vendorCoupons.filter(c => c.approval_status === "approved"),
    [vendorCoupons]
  );
  const businesses = useMemo(
    () => vendorBusinesses.filter(b => b.approval_status === "approved"),
    [vendorBusinesses]
  );

  const ALL_CATEGORIES = [
    "Attractions",
    "Beer / Drinks",
    "Accommodations",
    "Coffee Shops",
    "Dining",
    "Retail",
    "Transportation",
    "Golf / Mini",
    "Tours / Excursions",
    "Spa / Health",
    "Museums",
    "Misc",
  ];

  const businessFilteredCoupons = useMemo(
    () => selectedBusiness
      ? coupons.filter(c => String(c.business_id) === String(selectedBusiness.id))
      : coupons,
    [coupons, selectedBusiness]
  );

  const categoryBreakdown = useMemo(() => {
    const counts = {};
    businessFilteredCoupons.forEach(c => {
      const cat = c.discount_category || "Uncategorized";
      counts[cat] = (counts[cat] || 0) + 1;
    });
    return counts;
  }, [businessFilteredCoupons]);

  const visibleCoupons = useMemo(
    () => selectedCategory
      ? businessFilteredCoupons.filter(c => (c.discount_category || "Uncategorized") === selectedCategory)
      : businessFilteredCoupons,
    [businessFilteredCoupons, selectedCategory]
  );

  const bestSellingCoupons = useMemo(
    () => [...visibleCoupons]
      .sort((a, b) => (b.redemption_count ?? 0) - (a.redemption_count ?? 0))
      .slice(0, 6),
    [visibleCoupons]
  );

  const vendorAvgRating = useMemo(() => {
    const rated = coupons.filter(c => c.average_rating != null);
    if (rated.length === 0) return null;
    const total = rated.reduce((sum, c) => sum + parseFloat(c.average_rating), 0);
    return Math.round((total / rated.length) * 10) / 10;
  }, [coupons]);

  const vendorRatingCount = useMemo(
    () => coupons.reduce((sum, c) => sum + (c.rating_count ?? 0), 0),
    [coupons]
  );

  let [active, setActive] = useState(false);
  let sidebarController = () => {
    setActive(!active);
  };

    const handleCouponNavigateClick = (couponId) => {
        navigate(`/coupon/${couponId}`)
    }

    useEffect(() => {
        dispatch(fetchVendorById(id));
        dispatch(fetchCouponsByVendor(id));
        dispatch(fetchBusinessesByVendor(id));
    }, [id, dispatch]);

  if (!vendor) return null;

  return (
    <section className='vendor-two-details py-80'>
      <div className={`side-overlay ${active && "show"}`}></div>
      <div className='container container-lg'>
        <div className='vendor-two-details-wrapper d-flex flex-wrap align-items-start gap-24'>
          {/* Shop Sidebar Start */}
          <div className={`shop-sidebar ${active && "active"}`}>
            <button
              onClick={sidebarController}
              type='button'
              className='shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 text-white border-main-600'
            >
              <i className='ph ph-x' />
            </button>
            <div className='d-flex flex-column gap-12 px-lg-0 px-3 py-lg-0 py-4'>
              <div className='bg-neutral-600 rounded-8 p-24'>
                <div className='d-flex align-items-center justify-content-between'>
                  <span className='w-80 h-80 flex-center bg-white rounded-8 flex-shrink-0 overflow-hidden'>
                    {vendor?.image ? (
                      <img src={vendor.image} alt='' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    ) : (
                      <i className="bi bi-shop" style={{ fontSize: '1.75rem', color: '#9ca3af' }} />
                    )}
                  </span>
                  {/* <div className='d-flex flex-column gap-24'>
                    <button
                      type='button'
                      className='text-uppercase group border border-white px-16 py-8 rounded-pill text-white text-sm hover-bg-main-two-600 hover-text-white hover-border-main-two-600 transition-2 flex-center gap-8 w-100'
                    >
                      FOLLOW
                      <span className='text-xl d-flex text-main-two-600 group-item-white transition-2'>
                        {" "}
                        <i className='ph ph-storefront' />
                      </span>
                    </button>
                    <button
                      type='button'
                      className='text-uppercase group border border-white px-16 py-8 rounded-pill text-white text-sm hover-bg-main-two-600 hover-text-white hover-border-main-two-600 transition-2 flex-center gap-8 w-100'
                    >
                      Chat Now
                      <span className='text-xl d-flex text-main-two-600 group-item-white transition-2'>
                        {" "}
                        <i className='ph ph-storefront' />
                      </span>
                    </button>
                  </div> */}
                </div>
                <div className='mt-32'>
                  <h6 className='text-white fw-semibold mb-12'>
                    <Link to='/vendor-two-details' className=''>
                      {vendor.vendor_name}
                    </Link>
                  </h6>
                  {/* <span className='text-xs text-white mb-12'>
                    480589 Followers
                  </span> */}
                  <div className='flex-align gap-6'>
                    <div className='flex-align gap-8'>
                      {[1, 2, 3, 4, 5].map(s => (
                        <span key={s} className={`text-15 fw-medium d-flex ${s <= Math.round(vendorAvgRating || 0) ? 'text-warning-600' : 'text-gray-400'}`}>
                          <i className='ph-fill ph-star' />
                        </span>
                      ))}
                    </div>
                    <span className='text-xs fw-medium text-white'>{vendorAvgRating ?? '—'}</span>
                    <span className='text-xs fw-medium text-white'>({vendorRatingCount})</span>
                  </div>
                </div>
                {vendor.vendor_description && (
                  <div className='mt-32 pt-24 border-top border-neutral-500'>
                    <p className='text-white text-sm mb-0' style={{ lineHeight: '1.6', opacity: 0.85 }}>
                      {vendor.vendor_description}
                    </p>
                  </div>
                )}
              </div>
              <div className='border border-gray-50 rounded-8 p-24'>
                <h6 className='text-xl border-bottom border-gray-100 pb-24 mb-24'>
                  Product Category
                </h6>
                <ul className='max-h-540 overflow-y-auto scroll-sm'>
                  <li className='mb-24'>
                    <button
                      type='button'
                      onClick={() => setSelectedCategory(null)}
                      className={`text-start w-100 border-0 bg-transparent fw-medium ${!selectedCategory ? 'text-main-800 ' : 'text-gray-900 hover-text-main-800'}`}
                    >
                      All ({coupons.length})
                    </button>
                  </li>
                  {ALL_CATEGORIES.map(cat => (
                    <li key={cat} className='mb-24'>
                      <button
                        type='button'
                        onClick={() => setSelectedCategory(cat)}
                        className={`text-start w-100 border-0 bg-transparent fw-medium ${selectedCategory === cat ? 'text-main-800 ' : 'text-gray-900 hover-text-main-800'}`}
                      >
                        {cat} ({categoryBreakdown[cat] ?? 0})
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
              <div className='blog-sidebar border border-gray-100 rounded-8 p-32 mb-40'>
                <h6 className='text-xl mb-32 pb-32 border-bottom border-gray-100'>
                  Best Selling Coupons
                </h6>
                {bestSellingCoupons.length > 0 ? (
                  <div className='d-flex flex-column gap-24'>
                    {bestSellingCoupons.map(coupon => (
                      <div
                        key={coupon.id}
                        className='d-flex align-items-center flex-sm-nowrap flex-wrap gap-16'
                      >
                        <button
                          type='button'
                          onClick={() => handleCouponNavigateClick(coupon.id)}
                          className='w-76 h-76 flex-shrink-0 rounded-4 bg-main-50 flex-center border-0'
                        >
                          <span className='text-main-800  text-3xl d-flex'>
                            <i className='ph-fill ph-ticket' />
                          </span>
                        </button>
                        <div className='flex-grow-1' style={{ minWidth: 0, overflow: 'hidden' }}>
                          <h6 className='text-sm mb-6 fw-medium' style={{ overflow: 'hidden' }}>
                            <button
                              type='button'
                              onClick={() => handleCouponNavigateClick(coupon.id)}
                              className='border-0 bg-transparent text-start p-0 hover-text-main-800 d-block'
                              style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }}
                            >
                              {coupon.title}
                            </button>
                          </h6>
                          <div className='flex-align gap-4 mb-4'>
                            {[1,2,3,4,5].map(star => (
                              <span
                                key={star}
                                className={`text-xs fw-medium d-flex ${star <= Math.round(coupon.average_rating || 0) ? 'text-warning-600' : 'text-gray-300'}`}
                              >
                                <i className='ph-fill ph-star' />
                              </span>
                            ))}
                            <span className='text-xs fw-medium text-neutral-500 ms-4'>
                              ({coupon.redemption_count ?? 0} redeemed)
                            </span>
                          </div>
                          <span className='text-sm fw-semibold text-main-800 '>
                            ${coupon.dollar_savings_amount} savings
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className='text-gray-500 text-sm mb-0'>No coupons available.</p>
                )}
              </div>
            </div>
          </div>
          {/* Shop Sidebar End */}
          <div className='vendor-two-details__contents'>
            {/* Inner Banner Start */}
            <div>
              <div className='mb-48'>
                {/* Section Header */}
                <div className='d-flex align-items-center justify-content-between flex-wrap gap-16 mb-32'>
                  <div>
                    <h4 className='mb-8'>Vendor Businesses</h4>
                    <p className='text-gray-500 mb-0'>
                      Explore all business locations and storefronts operated by{" "}
                      <span className='fw-semibold text-main-900'>
                        {vendor.vendor_name}
                      </span>
                    </p>
                  </div>

                  <div className='bg-main-400 border border-main-100 px-20 py-12 rounded-8'>
                    <span className='text-main-800 fw-semibold'>
                      {Array.isArray(businesses) ? businesses.length : 0} Businesses
                    </span>
                  </div>
                </div>

                {/* Business Cards */}
                {Array.isArray(businesses) && businesses.length > 0 ? (
                  <div className='d-flex flex-wrap gap-24'>
                    {businesses.map((business, index) => {
                      const isActive = selectedBusiness?.id === business.id;
                      return (
                        <div
                          key={business.id || index}
                          style={{ flex: '0 0 280px', width: 280 }}
                        >
                          <div
                            onClick={() => setSelectedBusiness(isActive ? null : business)}
                            className={`h-100 p-24 border rounded-16 bg-white transition-2 position-relative ${isActive ? 'border-main-600 shadow-sm' : 'border-gray-100 hover-border-main-600'}`}
                            style={{ cursor: 'pointer' }}
                          >

                            {/* Filtering badge */}
                            {isActive && (
                              <div className='position-absolute top-0 start-0 mt-12 ms-12'>
                                <span className='bg-main-600 text-white text-xs px-8 py-4 rounded-pill d-flex align-items-center gap-4'>
                                  <i className='ph-fill ph-check-circle' /> Filtering
                                </span>
                              </div>
                            )}

                            {/* Business badge */}
                            <div className='position-absolute top-0 end-0 mt-12 me-12'>
                              <span className={`text-xs px-8 py-4 rounded-pill ${isActive ? 'bg-main-600 text-white' : 'bg-main-50 text-main-800 '}`}>
                                Business
                              </span>
                            </div>

                            {/* Business Icon */}
                            <div className={`w-48 h-48 rounded-circle flex-center mb-16 mt-40 ${isActive ? 'bg-main-600' : 'bg-main-50'}`}>
                              <span className={`text-xl d-flex ${isActive ? 'text-white' : 'text-main-800 '}`}>
                                <i className='ph-fill ph-storefront' />
                              </span>
                            </div>

                            {/* Business Name */}
                            <h5 className='mb-12' style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', lineHeight: '1.3', minHeight: '2.6em' }}>
                              {business.business_name}
                            </h5>

                            {/* Address */}
                            <div className='d-flex align-items-start gap-10 mb-16'>
                              <span className='text-main-800  text-lg d-flex mt-1'>
                                <i className='ph-fill ph-map-pin' />
                              </span>
                              <div>
                                <p className='mb-0 text-gray-700'>
                                  {business.address}
                                </p>
                                <span className='text-sm text-gray-500'>
                                  {business.city}, {business.zipcode}
                                </span>
                              </div>
                            </div>

                            {/* Phone */}
                            {business.phone_number && (
                              <div className='d-flex align-items-center gap-10 mb-24'>
                                <span className='text-main-800  text-lg d-flex'>
                                  <i className='ph-fill ph-phone-call' />
                                </span>
                                <span className='text-gray-700'>
                                  {business.phone_number}
                                </span>
                              </div>
                            )}

                            {/* Footer */}
                            <div className='pt-20 border-top border-gray-100 d-flex justify-content-between align-items-center'>
                              <span className={`text-sm fw-semibold ${business.active ? "text-success-600" : "text-danger-600"}`}>
                                {business.active ? "Active Business" : "Inactive"}
                              </span>
                              <span className={`text-sm fw-semibold ${isActive ? 'text-main-800 ' : 'text-gray-400'}`}>
                                {isActive ? 'Click to clear' : 'Click to filter'}
                              </span>
                            </div>

                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className='border border-gray-100 rounded-16 p-40 text-center bg-gray-50'>
                    <div className='mb-20'>
                      <span className='text-5xl text-gray-400 d-inline-flex'>
                        <i className='ph-light ph-storefront' />
                      </span>
                    </div>
                    <h5 className='mb-12'>No Businesses Available</h5>
                    <p className='text-gray-500 mb-0'>
                      This vendor has not added any businesses yet.
                    </p>
                  </div>
                )}
              </div>
            </div>
            {/* Inner Banner End */}
            {/* Search Filter Start */}
            <div className='d-flex align-items-center justify-content-between flex-wrap gap-16 mb-32'>
                  <div>
                    <h4 className='mb-8'>Vendor Coupons</h4>
                    <p className='text-gray-500 mb-0'>
                      {selectedBusiness ? (
                        <>
                          Showing coupons for{" "}
                          <span className='fw-semibold text-main-900'>{selectedBusiness.business_name}</span>
                          {" "}—{" "}
                          <button
                            type='button'
                            onClick={() => setSelectedBusiness(null)}
                            className='border-0 bg-transparent text-main-900 fw-semibold p-0 hover-text-main-700 text-decoration-underline'
                          >
                            Show all
                          </button>
                        </>
                      ) : (
                        <>
                          Explore all coupons operated by{" "}
                          <span className='fw-semibold text-main-800 '>{vendor.vendor_name}</span>
                        </>
                      )}
                    </p>
                  </div>

                  <div className='bg-main-400 border border-main-100 px-20 py-12 rounded-8'>
                    <span className='text-main-800 fw-semibold'>
                      {visibleCoupons.length} {selectedCategory ? `"${selectedCategory}"` : ""} Coupon{visibleCoupons.length !== 1 ? "s" : ""}
                    </span>
                  </div>
                </div>
            {/* Search Filter End */}
            {/* Products Start */}
            <div className={`list-grid-wrapper grid-cols-4 ${grid && "list-view"}`}>
              {
                Array.isArray(visibleCoupons) && visibleCoupons.length > 0 ? (
                    visibleCoupons.map((coupon) => {
                        return (
                                    <div className='product-card p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2' style={{ height: '500px', display: 'flex', flexDirection: 'column', overflow: 'hidden', minWidth: 0, width: '100%' }}>
                                      <div
                                        className='product-card__thumb rounded-8 bg-gray-50 position-relative'
                                        style={{ overflow: 'hidden', flexShrink: 0, cursor: 'pointer' }}
                                        onClick={() => handleCouponNavigateClick(coupon.id)}
                                      >
                                        <span className='product-card__badge bg-main-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0'>
                                          New
                                        </span>
                                        {coupon.image_url ? (
                                          <img
                                            src={coupon.image_url}
                                            alt=''
                                            style={{ width: '100%', height: '100%', maxWidth: 'none', maxHeight: 'none', objectFit: 'cover', position: 'absolute', inset: 0 }}
                                          />
                                        ) : (
                                          <img
                                            src='assets/images/thumbs/trending-three-img1.png'
                                            alt=''
                                            className='w-auto max-w-unset'
                                          />
                                        )}
                                        {isAuthenticated && (
                                          <button
                                            type="button"
                                            onClick={(e) => handleBookmarkToggle(e, coupon.id)}
                                            style={{ position: "absolute", top: 14, right: 14, zIndex: 3, background: "rgba(255,255,255,0.85)", border: "none", borderRadius: "50%", width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", backdropFilter: "blur(4px)", boxShadow: "0 1px 4px rgba(0,0,0,0.12)" }}
                                          >
                                            <i className={bookmarkedIds.includes(coupon.id) ? "ph-fill ph-bookmark-simple" : "ph ph-bookmark-simple"} style={{ fontSize: 20, color: bookmarkedIds.includes(coupon.id) ? "#2575fc" : "#9ca3af" }} />
                                          </button>
                                        )}
                                      </div>
                                      <div className='product-card__content w-100 mt-16' style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', minWidth: 0 }}>
                                        <div style={{ height: '24px', flexShrink: 0, overflow: 'hidden', display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '8px' }}>
                                          {coupon.business_name ? (
                                            <>
                                              <span className="text-tertiary-600 text-sm d-flex" style={{ flexShrink: 0 }}><i className="ph-fill ph-storefront" /></span>
                                              <span className="text-lg fw-semibold text-gray-500" style={{ fontFamily: "var(--heading-font)", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block', minWidth: 0 }}>{coupon.business_name}</span>
                                            </>
                                          ) : null}
                                        </div>
                                        <div className='flex-align gap-6' style={{ flexShrink: 0 }}>
                                          <div className='flex-align gap-4'>
                                            {[1,2,3,4,5].map(star => (
                                              <span key={star} className={`text-xs fw-medium d-flex ${star <= Math.round(coupon.average_rating || 0) ? 'text-warning-600' : 'text-gray-300'}`}>
                                                <i className='ph-fill ph-star' />
                                              </span>
                                            ))}
                                          </div>
                                          <span className='text-xs fw-medium text-gray-500'>{coupon.average_rating ?? "—"}</span>
                                          <span className='text-xs fw-medium text-gray-500'>({coupon.rating_count ?? 0})</span>
                                        </div>
                                        <h6 className='title text-lg fw-semibold mt-12 mb-8' style={{ flexShrink: 0 }}>
                                          <div
                                            onClick={() => handleCouponNavigateClick(coupon.id)}
                                            className='link d-block'
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                          >
                                            {coupon.title}
                                          </div>
                                        </h6>
                                        <p className='text-sm text-gray-500 mb-8' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flexShrink: 0, minHeight: '20px' }}>
                                          {coupon.description || ' '}
                                        </p>
                                        <div style={{ marginTop: 'auto', flexShrink: 0 }}>
                                          <div className='product-card__price flex-align gap-4 mt-12 mb-12'>
                                            <span className='text-heading text-md fw-semibold'>${coupon.dollar_savings_amount}</span>
                                            <span className='text-gray-500 text-sm fw-medium'>In Savings</span>
                                            <span style={{ width: '1px', height: '14px', backgroundColor: '#d1d5db', display: 'inline-block', margin: '0 4px' }} />
                                            <span className='text-main-800 text-sm fw-semibold'>{coupon.saving_percentage}% Off</span>
                                          </div>
                                          {isAuthenticated && isSubscribed ? (
                                            <Link
                                              to={`/coupon/${coupon.id}`}
                                              className='product-card__cart w-100 btn bg-main-800 text-white hover-bg-main-700 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium w-100'
                                            >
                                              Redeem Coupon <i className='ph ph-shopping-cart' />
                                            </Link>
                                          ) : (
                                            <Link
                                              to={isAuthenticated ? '/cart' : '/account-login'}
                                              state={{ from: `/coupon/${coupon.id}` }}
                                              className='product-card__cart w-100 btn bg-main-800 text-white hover-bg-main-700 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium w-100'
                                            >
                                              Buy Fun Card <i className='ph ph-shopping-cart' />
                                            </Link>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    )
                                        })
                                    ) : (
                                        <div className='text-gray-500 py-24'>
                                          {selectedCategory
                                            ? `No coupons found in "${selectedCategory}"`
                                            : "No coupons available"}
                                        </div>
                                    )
                                }
            </div>
            {/* Products End */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VendorTwoDetails;
